module.exports = __webpack_public_path__ + "img/split-view-preview.65c6eb61.webp";